import React, { Component } from "react";
import { Link } from "react-router-dom";
import 'bootstrap-icons/font/bootstrap-icons.css';
import companyLogo from 'assets/funnel/power_serv.jpg';
import heroImg from 'assets/funnel/lackier_main.png';
import groupImg from 'assets/funnel/lackier_group.png';
import jobDetailsImg from 'assets/funnel/lackier_job_details.png';

/*
 * Redesign notes
 * --------------
 * Palette:  navy #17293C · steel #90AFC4 · mist #EEF3F7 · red #D5232E · ink #1D2732
 * Type:     Barlow Condensed (display) + Barlow (body) — DIN-inspired, the
 *           typographic vernacular of German/Austrian rail signage.
 * Signature: the "7-Schichten" bar — seven stacked paint layers (primer → gloss),
 *           taken directly from the Mehrschichtlackierung in the job content.
 *           Used under section eyebrows as a divider.
 * UX:       accordions removed (content that sells shouldn't be hidden),
 *           one consistent CTA, sticky bottom apply bar, key-facts strip up top.
 */

const LayerBar = ({ width = 72 }) => (
  <div className="ji-layers" style={{ width }} aria-hidden="true">
    {['#5A6672', '#7B8894', '#93A6B4', '#A3BACB', '#90AFC4', '#7FA4BE', '#D5232E'].map((c, i) => (
      <span key={i} style={{ background: c }} />
    ))}
  </div>
);

class JobInfo extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Lackierer:in (m/w/d) | POWERSERV Austria GmbH";
  }

  get quizLink() {
    return `/job/quiz${this.props.location.search}`;
  }

  renderStyles() {
    return (
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=Barlow:wght@400;500;600;700&display=swap');

        .ji-page {
          font-family: 'Barlow', system-ui, -apple-system, sans-serif;
          color: #1D2732;
          background: #fff;
          max-width: 480px;
          margin: 0 auto;
          padding-bottom: 96px; /* room for sticky CTA bar */
        }
        .ji-display {
          font-family: 'Barlow Condensed', 'Barlow', sans-serif;
          font-weight: 700;
          letter-spacing: 0.01em;
          text-transform: uppercase;
        }
        .ji-eyebrow {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.14em;
          font-size: 13px;
          color: #6B7D8D;
          margin-bottom: 6px;
        }
        .ji-layers {
          display: flex;
          flex-direction: column;
          gap: 2px;
          margin: 10px 0 20px;
        }
        .ji-layers span { display: block; height: 3px; border-radius: 2px; }

        .ji-cta {
          display: block;
          width: 100%;
          background: #D5232E;
          color: #fff;
          text-align: center;
          font-weight: 700;
          font-size: 16px;
          padding: 15px 20px;
          border-radius: 12px;
          text-decoration: none;
          box-shadow: 0 6px 16px rgba(213,35,46,.28);
          transition: transform .12s ease, background .12s ease;
        }
        .ji-cta:hover, .ji-cta:focus-visible { background: #B81C26; color: #fff; transform: translateY(-1px); }
        .ji-cta-sub {
          display: flex; align-items: center; justify-content: center; gap: 6px;
          font-size: 12.5px; color: #6B7D8D; margin-top: 10px;
        }

        .ji-stickybar {
          position: fixed; bottom: 0; left: 50%; transform: translateX(-50%);
          width: 100%; max-width: 480px; z-index: 50;
          background: rgba(255,255,255,.96);
          backdrop-filter: blur(8px);
          border-top: 1px solid #E3EAF0;
          padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
        }
        .ji-stickybar .ji-cta { padding: 13px 16px; font-size: 15px; box-shadow: none; }

        .ji-hero { position: relative; height: 400px; overflow: hidden; background: #17293C; }
        .ji-hero img.ji-hero-img {
          width: 100%; height: 100%; object-fit: cover; object-position: center;
          opacity: .92;
        }
        .ji-hero::after {
          content: ''; position: absolute; inset: 0;
          background: linear-gradient(180deg, rgba(23,41,60,.30) 0%, rgba(23,41,60,0) 35%, rgba(23,41,60,.88) 78%, #17293C 100%);
        }
        .ji-hero-content { position: absolute; left: 0; right: 0; bottom: 0; z-index: 2; padding: 20px; color: #fff; }
        .ji-hero-logo { position: absolute; top: 14px; left: 16px; z-index: 2; height: 40px; background: rgba(255,255,255,.95); border-radius: 8px; padding: 5px 10px; }
        .ji-hero-logo img { height: 100%; object-fit: contain; }
        .ji-chip {
          display: inline-block; background: #90AFC4; color: #14222F;
          font-family: 'Barlow Condensed', sans-serif; font-weight: 600; text-transform: uppercase;
          letter-spacing: .1em; font-size: 12.5px; padding: 4px 10px; border-radius: 4px; margin-bottom: 10px;
        }
        .ji-hero h1 { font-size: 42px; line-height: .98; margin: 0 0 4px; }
        .ji-hero .ji-hero-sub { color: #C6D6E2; font-size: 15px; margin: 0; }

        .ji-facts {
          display: grid; grid-template-columns: repeat(2, 1fr);
          background: #17293C; color: #fff; padding: 0 16px 18px; gap: 8px;
        }
        .ji-fact { background: rgba(255,255,255,.07); border: 1px solid rgba(144,175,196,.28); border-radius: 10px; padding: 10px 8px; text-align: center; }
        .ji-fact b { display: block; font-family: 'Barlow Condensed', sans-serif; font-size: 21px; font-weight: 700; line-height: 1.05; }
        .ji-fact span { font-size: 11.5px; color: #A9BFCF; }

        .ji-section { padding: 32px 20px 8px; }
        .ji-section h2 { font-size: 30px; line-height: 1.02; margin: 0; }
        .ji-section-alt { background: #EEF3F7; padding-bottom: 32px; margin-top: 24px; }

        .ji-item { display: flex; gap: 14px; align-items: flex-start; margin-bottom: 18px; }
        .ji-icon {
          flex-shrink: 0; width: 40px; height: 40px; border-radius: 10px;
          background: #E4EDF3; color: #3E5A70;
          display: flex; align-items: center; justify-content: center; font-size: 19px;
        }
        .ji-item b { display: block; font-size: 15.5px; margin-bottom: 2px; }
        .ji-item p { margin: 0; font-size: 14px; color: #55677A; line-height: 1.5; }

        .ji-media { border-radius: 14px; overflow: hidden; height: 240px; margin: 18px 0 22px; position: relative; }
        .ji-media img { width: 100%; height: 100%; object-fit: cover; }
        .ji-media-tag {
          position: absolute; bottom: 0; left: 0;
          background: rgba(23,41,60,.85); color: #fff;
          font-family: 'Barlow Condensed', sans-serif; font-weight: 700; text-transform: uppercase;
          letter-spacing: .04em; font-size: 17px; line-height: 1.15;
          padding: 10px 16px; border-radius: 0 12px 0 0;
        }

        .ji-check { list-style: none; padding: 0; margin: 0 0 8px; }
        .ji-check li { display: flex; gap: 10px; align-items: flex-start; margin-bottom: 10px; font-size: 14.5px; line-height: 1.45; }
        .ji-check li i { color: #D5232E; font-size: 16px; margin-top: 1px; flex-shrink: 0; }
        .ji-check.ji-check-steel li i { color: #3E5A70; }

        .ji-note {
          background: #17293C; color: #DCE7EF; border-radius: 12px;
          padding: 16px 18px; font-size: 14px; line-height: 1.55; margin: 20px 0;
          display: flex; gap: 12px; align-items: flex-start;
        }
        .ji-note i { color: #90AFC4; font-size: 20px; flex-shrink: 0; }

        .ji-final {
          background: #17293C; color: #fff; margin-top: 36px;
          padding: 36px 20px; text-align: center;
        }
        .ji-final h2 { font-size: 32px; margin: 0 0 8px; }
        .ji-final p { color: #B9CBD9; font-size: 14.5px; }

        .ji-footer { padding: 28px 20px calc(20px + env(safe-area-inset-bottom)); font-size: 12px; color: #7A8A98; text-align: center; }
        .ji-footer a { color: #3E5A70; }

        @media (prefers-reduced-motion: reduce) {
          .ji-cta { transition: none; }
        }
      `}</style>
    );
  }

  renderCta(sub) {
    return (
      <div style={{ margin: '20px 0 8px' }}>
        <Link to={this.quizLink} className="ji-cta">Jetzt in 60 Sekunden bewerben</Link>
        {sub && (
          <div className="ji-cta-sub">
            <i className="bi bi-shield-check" /> Ohne Lebenslauf starten – nur ein paar kurze Fragen
          </div>
        )}
      </div>
    );
  }

  renderStickyBar() {
    return (
      <div className="ji-stickybar">
        <Link to={this.quizLink} className="ji-cta">
          Jetzt bewerben <span style={{ fontWeight: 400, opacity: .85 }}>· dauert unter 60 Sek.</span>
        </Link>
      </div>
    );
  }

  renderHero() {
    return (
      <>
        <header className="ji-hero">
          <div className="ji-hero-logo">
            <img src={companyLogo} alt="POWERSERV Austria GmbH" />
          </div>
          <img src={heroImg} alt="" className="ji-hero-img" />
          <div className="ji-hero-content">
            <span className="ji-chip">Vollzeit · Schienenfahrzeugtechnik</span>
            <h1 className="ji-display">Lackierer:in<br />(m/w/d)</h1>
          </div>
        </header>
        <div className="ji-facts">
          <div className="ji-fact"><b>€ 3.058</b><span>Monatslohn + Überstunden</span></div>
          <div className="ji-fact"><b>38,5 h</b><span>geregelte Woche</span></div>
        </div>
      </>
    );
  }

  renderMoechtestDu() {
    const items = [
      { icon: 'bi-brush', text: 'dein Handwerk als Lackierer:in in einem international erfolgreichen Unternehmen der Schienenfahrzeugtechnik einsetzen?' },
      { icon: 'bi-train-front', text: 'an beeindruckenden Projekten arbeiten und Züge sowie Waggone mit hochwertigen Mehrschichtlackierungen veredeln?' },
      { icon: 'bi-award', text: 'langfristig in einem stabilen Betrieb mit echter Übernahmemöglichkeit durch unseren Kunden tätig sein?' },
    ];
    return (
      <section className="ji-section">
        <div className="ji-eyebrow">Dein nächster Schritt</div>
        <h2 className="ji-display">Möchtest du gerne…</h2>
        <LayerBar />
        {items.map((item, i) => (
          <div key={i} className="ji-item">
            <div className="ji-icon"><i className={`bi ${item.icon}`} /></div>
            <p style={{ fontSize: 15, color: '#1D2732' }}>…{item.text}</p>
          </div>
        ))}
        {this.renderCta(true)}
      </section>
    );
  }

  renderVorteile() {
    const benefits = [
      { icon: 'bi-clock', title: '38,5-Stunden-Woche', desc: 'Geregelter 2-Schichtbetrieb zwischen 06:00 und 22:00 Uhr.' },
      { icon: 'bi-cash-stack', title: '€ 3.058,– Monatslohn', desc: 'Überstunden werden vollständig ausbezahlt – kein Zeitausgleichskonto.' },
      { icon: 'bi-person-check', title: 'Echte Übernahmechance', desc: 'Langfristige Perspektive mit Übernahmemöglichkeit durch unseren Kunden.' },
      { icon: 'bi-layers', title: 'Abwechslungsreiche Arbeit', desc: 'Von Schleifen und Kitten bis zur 7-Schicht-Lackierung – kein Tag wie der andere.' },
      { icon: 'bi-geo-alt-fill', title: '1110 Wien', desc: 'Öffentlich erreichbar.' },
      { icon: 'bi-building', title: 'Internationaler Betrieb', desc: 'Führender Anbieter für Instandhaltung und Weiterentwicklung von Schienenfahrzeugen.' },
    ];
    return (
      <section className="ji-section ji-section-alt">
        <div className="ji-eyebrow">Vorteile &amp; Benefits</div>
        <h2 className="ji-display">Das bieten wir dir</h2>
        <LayerBar />
        {benefits.map((b, i) => (
          <div key={i} className="ji-item">
            <div className="ji-icon"><i className={`bi ${b.icon}`} /></div>
            <div>
              <b>{b.title}</b>
              <p>{b.desc}</p>
            </div>
          </div>
        ))}
        {this.renderCta()}
      </section>
    );
  }

  renderAufgaben() {
    const tasks = [
      'Lackieren von Zügen und Waggonen',
      'Schleifen und Kitten von Zugoberflächen',
      'Arbeiten mit Lackpistolen',
      'Mehrschichtlackierung (7 Schichten)',
    ];
    const requirements = [
      'Abgeschlossene Berufsausbildung mit LAP als Lackierer oder Karosseriebautechniker (m/w/d)',
      'Mindestens 2 Jahre Berufserfahrung als Lackierer',
      'Deutschkenntnisse mindestens B2',
      'Selbstständige Arbeitsweise',
      'Teamfähigkeit und Verlässlichkeit',
      'Einwandfreier Leumund',
      'Überstundenbereitschaft auch am Samstag',
      'Bereitschaft für 2-Schichtbetrieb (06:00 – 22:00 Uhr)',
    ];
    return (
      <section className="ji-section">
        <div className="ji-eyebrow">Aufgaben &amp; Anforderungen</div>
        <h2 className="ji-display">Mehr als nur Farbe</h2>
        <LayerBar />
        <div className="ji-media">
          <img src={jobDetailsImg} alt="" />
          <div className="ji-media-tag">Präzision in<br />7 Schichten</div>
        </div>

        <h3 style={{ fontSize: 17, fontWeight: 700, marginBottom: 12 }}>Deine Aufgaben</h3>
        <ul className="ji-check">
          {tasks.map((t, i) => (
            <li key={i}><i className="bi bi-check-circle-fill" />{t}</li>
          ))}
        </ul>

        <div className="ji-note">
          <i className="bi bi-hand-thumbs-up" />
          <span>Eine spannende, herausfordernde und abwechslungsreiche Position – jeder Waggon ist ein sichtbares Ergebnis deiner Arbeit.</span>
        </div>

        <h3 style={{ fontSize: 17, fontWeight: 700, marginBottom: 12 }}>Das bringst du mit</h3>
        <ul className="ji-check ji-check-steel">
          {requirements.map((r, i) => (
            <li key={i}><i className="bi bi-check-circle" />{r}</li>
          ))}
        </ul>
        {this.renderCta(true)}
      </section>
    );
  }

  renderDasSindWir() {
    return (
      <section className="ji-section ji-section-alt">
        <div className="ji-eyebrow">Das sind wir</div>
        <h2 className="ji-display">Gemeinsam erfolgreich</h2>
        <LayerBar />
        <div className="ji-media">
          <img src={groupImg} alt="Das Team von POWERSERV" />
        </div>
        <p style={{ fontSize: 14.5, lineHeight: 1.6, color: '#3B4A59' }}>
          Wir bei POWERSERV Austria stellen Menschen in den Mittelpunkt – Bewerber:innen, Mitarbeiter:innen und Kund:innen.
          Unser Anspruch ist es, durch Qualität, persönliche Betreuung und Engagement die besten Lösungen in der
          Personaldienstleistung zu bieten. Als zugelassene Personalvermittlerin setzen wir auf nachhaltiges Wachstum,
          langjährige Partnerschaften und entwickeln uns laufend im Einklang mit den Markttrends weiter.
          Unsere Vision: arbeitssuchenden Menschen die passenden Karrieremöglichkeiten eröffnen und
          Unternehmen mit den richtigen Mitarbeiter:innen zusammenbringen.
        </p>
      </section>
    );
  }

  renderFinalCta() {
    return (
      <section className="ji-final">
        <div className="ji-eyebrow" style={{ color: '#90AFC4' }}>Bereit?</div>
        <h2 className="ji-display">Dann bist du bei uns genau richtig!</h2>
        <p>Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.</p>
        <Link to={this.quizLink} className="ji-cta" style={{ marginTop: 8 }}>
          Jetzt in 60 Sekunden bewerben
        </Link>
      </section>
    );
  }

  renderFooter() {
    return (
      <footer className="ji-footer">
        <p style={{ marginBottom: 18 }}>
          Aus Gründen der Lesbarkeit wird auf dieser Website darauf verzichtet, durchgehend geschlechtsspezifische
          Formulierungen zu verwenden. Soweit personenbezogene Bezeichnungen nur in männlicher Form angeführt sind,
          beziehen sie sich auf Mann, Frau und Divers in gleicher Weise. Dies soll jedoch keinesfalls eine
          Geschlechterdiskriminierung oder eine Verletzung des Gleichheitsgrundsatzes zum Ausdruck bringen.
        </p>
        <div style={{ fontWeight: 600, color: '#1D2732' }}>Powered by ZoneAid</div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
          <Link target="_blank" rel="noopener noreferrer" to="/job/impressum">Impressum</Link>
          <Link target="_blank" rel="noopener noreferrer" to="/job/agb">Nutzungsbedingungen</Link>
          <Link target="_blank" rel="noopener noreferrer" to="/job/datenschutz">Datenschutzerklärung</Link>
        </div>
      </footer>
    );
  }

  render() {
    return (
      <div className="ji-page">
        {this.renderStyles()}
        {this.renderHero()}
        {this.renderMoechtestDu()}
        {this.renderVorteile()}
        {this.renderAufgaben()}
        {this.renderDasSindWir()}
        {this.renderFinalCta()}
        {this.renderFooter()}
        {this.renderStickyBar()}
      </div>
    );
  }
}

export default JobInfo;